import { Component, HostBinding, OnInit } from '@angular/core';

/**
 * Popover Component
 *
 * The popover component that will be tethered to a host
 * element.
 *
 * NOTE: currently this is an extremely basic component so
 * no unit test is needed.
 */
@Component({
  selector: 'cf-popover',
  template: `
    <div class="arrow" x-arrow></div>
    <div class="popover-body">
      <ng-content></ng-content>
    </div>
  `
})
export class PopoverComponent implements OnInit {
  modalPopover = false;
  customClasses = '';

  @HostBinding('style.maxWidth') maxWidth;
  @HostBinding('class') classes;

  ngOnInit() {
    this.classes = this.modalPopover ?
      'popover bs-popover-auto is-modal-popover ' + this.customClasses :
      'popover bs-popover-auto ' + this.customClasses;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/datepicker/popover/popover.component.ts